import {Component, Inject, OnInit} from '@angular/core';
import {IContact} from '../../../../core/models';
import {IChatRoom} from '../../../../dashboard/inbox/helpers/chat-box.component';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-chat-dialog',
  templateUrl: './chat-dialog.component.html',
  styleUrls: ['./chat-dialog.component.css']
})
export class ChatDialogComponent implements OnInit {
  currentPartner = {} as IContact;
  messagesList = [] as IChatRoom[];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {currentPartner: IContact, messagesList: IChatRoom[]},
    private mdDialogRef: MatDialogRef<ChatDialogComponent>,
  ) { }

  ngOnInit() {
    if (this.data) {
      this.currentPartner = this.data.currentPartner;
      this.messagesList = this.data.messagesList;
    }
  }

  close() {
    this.mdDialogRef.close();
  }
}
